import Layout from "../../../Layouts/Layout";
import { KpiCards } from "./components/KpiCards";
import SalesReport from "./components/SalesReport";
import { TopReps } from "./components/TopReps";
import AccountIssues from "./components/AccountIssues";
import ActivityFeed from "./components/ActivityFeed";
import SocialFeed from "./components/SocialFeed";
import FiberCompanyList from "./components/FiberCompanyList";
import { useContext, useState } from "react";
import { UserContext } from "../../../App";

export default function DashboardNew() {
	const [selectedFiberCompany, setSelectedFiberCompany] = useState(null);
	const user = useContext(UserContext);

	return (
		<Layout>
			<div className="pt-4 pb-3 lg:pb-1 lg:pt-8">
				<FiberCompanyList
					selected={selectedFiberCompany}
					setSelected={setSelectedFiberCompany}
				/>
			</div>
			<div className="p-4 pt-0 flex flex-col gap-6 lg:gap-4 lg:p-8 lg:pt-0">
				<KpiCards fiberCompanyId={selectedFiberCompany} />

				<div className="flex flex-col gap-6 lg:gap-4 lg:flex-row">
					<SalesReport fiberCompanyId={selectedFiberCompany} />
					{user.userType !== "SalesRep" && (
						<TopReps fiberCompanyId={selectedFiberCompany} />
					)}
				</div>
				{user.userType === "SuperAdmin" && (
					<div className="flex">
						<AccountIssues fiberCompanyId={selectedFiberCompany} />
					</div>
				)}

				<div className="flex flex-col gap-6 lg:gap-4 lg:grid lg:grid-cols-2">
					<ActivityFeed />
					<SocialFeed />
				</div>
			</div>
		</Layout>
	);
}
